/**
 * Checks if the given value is defined (not `undefined`).
 *
 * @template T - The type of the value to check.
 * @param t - The value to check.
 * @returns - Returns `true` if the value is defined, otherwise `false`.
 */
export const isDefined = <T>(t?: T): t is T => t !== undefined;
